import React, { useState, useCallback, useEffect } from 'react';
import EffectDoc from './effects/EffectDoc.js';
import DocLink from './DocLink.js';
import {standard, flow} from './effects/definitions.js';

const SUB_TYPES = ["Basic", "Conditional Flow"];
export default (props) => {
    let [selected, setSelected] = useState(undefined);
    let types = ["Basic", ...standard(), "Conditional Flow", ...flow()];

    useEffect(() => {
        // switch to sub sequence we want
        props.sequencerEngine.switchToSubSequence(
            props.sequencerEngine.subSequences[0].id);
    }, [props.sequencerEngine]);

    return (
        <div className="midi-effects">
          <div className="effects-sidebar">
            {types.map(
                type => SUB_TYPES.includes(type)  ?
                <div className="sidebar-divider">{type}</div> :
                <div
                  onClick={() => setSelected(type === selected ? undefined : type)}
                  className={selected === type ? "option selected" : "option"}>{type}</div>)}
          </div>
          {selected ? 
           <EffectDoc
             sequencerEngine={props.sequencerEngine}
             name={selected}
             doc={standard(selected) || flow(selected)}/> :
           <div className="definition">
             <p>
               MIDI effects transform triggers in the sequencer, as opposed to audio-effects which alter audio signal. They can transform a simple pattern into a complex one. Triggers go from the sequencer through to each MIDI Effect, in series.
             </p>
             <img src="/midi-fx-flow.svg"/>
             <p>
               While called MIDI effects, they are not limited to MIDI's 80's era specification. In fact, you can control any parameter in Zequencer through MIDI effects, from step-parameters to even synth patches. Using the MIDI Effect Rack, you can patch conditinal flow of triggers, that occur probabilistically or deterministically, changing patterns when certain conditions are met. You can even send triggers to other tracks and grab parameters from other tracks.
             </p>
             <p>
               Zequencer comes with dozens of powerful MIDI effects that can be linked together in any number of ways. Click through the list on the left to get familiar with them.
             </p>
           </div>}
        </div>
    );
 
}
 
